import { ACTIONS } from '_redux/actions';
import { get } from './api';

export function fetchNavigation(params) {
  return get('navigation-items',
    params,
    ACTIONS.NAVIGATION.FETCH_NAVIGATION,
    ACTIONS.NAVIGATION.FETCH_NAVIGATION_SUCCESS,
    ACTIONS.NAVIGATION.FETCH_NAVIGATION_ERROR,
    false);
}
